import { render, staticRenderFns } from "./waybillCopy.vue?vue&type=template&id=c98d8922&scoped=true&"
import script from "./waybillCopy.vue?vue&type=script&lang=js&"
export * from "./waybillCopy.vue?vue&type=script&lang=js&"
import style0 from "./waybillCopy.vue?vue&type=style&index=0&id=c98d8922&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98d8922",
  null
  
)

export default component.exports